/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import React from 'react';
import RenderWhen from '@vlinder-web/react-when-module-react';
import { Image } from 'react-bootstrap';

import * as S from './styles';

export interface IBrandHeaderProps {
  title?: string;
  logo?: string;
  logoWidth?: string | number;
  logoHeight?: string | number;
  backgroundColor?: string;
}

export const BrandHeader = ({
  title,
  logo,
  logoHeight,
  logoWidth,
  backgroundColor,
}: IBrandHeaderProps) => {
  return (
    <RenderWhen>
      <RenderWhen.If isTrue={!!title || !!logo}>
        <S.BrandNavBar
          sticky={'top'}
          fixed={'top'}
          backgroundColor={backgroundColor}
        >
          <S.BrandHeader backgroundColor={backgroundColor}>
            <RenderWhen>
              <RenderWhen.If isTrue={!!logo}>
                <Image src={logo} width={logoWidth} height={logoHeight} />
              </RenderWhen.If>
              <RenderWhen.If isTrue={!!title}>
                <h2>{title}</h2>
              </RenderWhen.If>
            </RenderWhen>
          </S.BrandHeader>
        </S.BrandNavBar>
      </RenderWhen.If>
    </RenderWhen>
  );
};

BrandHeader.defaultProps = {
  backgroundColor: '#F2F4F6',
  logoHeight: 'auto',
};
